export var AcademicSessionOrderField;
(function (AcademicSessionOrderField) {
    AcademicSessionOrderField["ID"] = "ID";
    AcademicSessionOrderField["NAME"] = "NAME";
    AcademicSessionOrderField["ORGANIZATION_ID"] = "ORGANIZATION_ID";
    AcademicSessionOrderField["SOURCE_ID"] = "SOURCE_ID";
    AcademicSessionOrderField["SOURCE_KIND_ID"] = "SOURCE_KIND_ID";
})(AcademicSessionOrderField || (AcademicSessionOrderField = {}));
export var AcademicSessionStatus;
(function (AcademicSessionStatus) {
    AcademicSessionStatus["CURRENT"] = "CURRENT";
    AcademicSessionStatus["FUTURE"] = "FUTURE";
    AcademicSessionStatus["PREVIOUS"] = "PREVIOUS";
})(AcademicSessionStatus || (AcademicSessionStatus = {}));
export var Affix;
(function (Affix) {
    Affix["PREFIX"] = "PREFIX";
    Affix["SUFFIX"] = "SUFFIX";
})(Affix || (Affix = {}));
export var AssetChangeAction;
(function (AssetChangeAction) {
    AssetChangeAction["CREATED"] = "CREATED";
    AssetChangeAction["DELETED"] = "DELETED";
    AssetChangeAction["REMOVED"] = "REMOVED";
    AssetChangeAction["RESTORED"] = "RESTORED";
    AssetChangeAction["SAVED"] = "SAVED";
})(AssetChangeAction || (AssetChangeAction = {}));
export var AssetOrderField;
(function (AssetOrderField) {
    AssetOrderField["DATE_CREATED"] = "DATE_CREATED";
    AssetOrderField["DATE_REMOVED"] = "DATE_REMOVED";
    AssetOrderField["DESCRIPTION"] = "DESCRIPTION";
    AssetOrderField["FILENAME"] = "FILENAME";
    AssetOrderField["ID"] = "ID";
    AssetOrderField["TITLE"] = "TITLE";
    AssetOrderField["TYPE"] = "TYPE";
})(AssetOrderField || (AssetOrderField = {}));
export var AssetTagOrderField;
(function (AssetTagOrderField) {
    AssetTagOrderField["ID"] = "ID";
    AssetTagOrderField["TAG"] = "TAG";
    AssetTagOrderField["VALUE"] = "VALUE";
})(AssetTagOrderField || (AssetTagOrderField = {}));
export var AssetType;
(function (AssetType) {
    AssetType["ARCHIVE"] = "ARCHIVE";
    AssetType["AUDIO"] = "AUDIO";
    AssetType["DOCUMENT"] = "DOCUMENT";
    AssetType["IMAGE"] = "IMAGE";
    AssetType["SVG"] = "SVG";
    AssetType["VIDEO"] = "VIDEO";
})(AssetType || (AssetType = {}));
export var AssigneeType;
(function (AssigneeType) {
    AssigneeType["STUDENT"] = "STUDENT";
    AssigneeType["USER"] = "USER";
})(AssigneeType || (AssigneeType = {}));
export var AudioVoice;
(function (AudioVoice) {
    AudioVoice["FEMALE"] = "FEMALE";
    AudioVoice["MALE"] = "MALE";
})(AudioVoice || (AudioVoice = {}));
export var ClassroomOrderField;
(function (ClassroomOrderField) {
    ClassroomOrderField["DATE_ARCHIVED"] = "DATE_ARCHIVED";
    ClassroomOrderField["DATE_CREATED"] = "DATE_CREATED";
    ClassroomOrderField["DATE_REMOVED"] = "DATE_REMOVED";
    ClassroomOrderField["ID"] = "ID";
    ClassroomOrderField["NAME"] = "NAME";
    ClassroomOrderField["ORGANIZATION_ID"] = "ORGANIZATION_ID";
    ClassroomOrderField["SOURCE_ID"] = "SOURCE_ID";
    ClassroomOrderField["SOURCE_KIND_ID"] = "SOURCE_KIND_ID";
})(ClassroomOrderField || (ClassroomOrderField = {}));
export var ClassroomPrivilegeOrderField;
(function (ClassroomPrivilegeOrderField) {
    ClassroomPrivilegeOrderField["DISPLAY_NAME"] = "DISPLAY_NAME";
    ClassroomPrivilegeOrderField["ID"] = "ID";
    ClassroomPrivilegeOrderField["NAME"] = "NAME";
})(ClassroomPrivilegeOrderField || (ClassroomPrivilegeOrderField = {}));
export var ClassroomRoleClassification;
(function (ClassroomRoleClassification) {
    ClassroomRoleClassification["COEDUCATOR"] = "COEDUCATOR";
    ClassroomRoleClassification["EDUCATOR"] = "EDUCATOR";
})(ClassroomRoleClassification || (ClassroomRoleClassification = {}));
export var ClassroomRoleOrderField;
(function (ClassroomRoleOrderField) {
    ClassroomRoleOrderField["APP"] = "APP";
    ClassroomRoleOrderField["DISPLAY_NAME"] = "DISPLAY_NAME";
    ClassroomRoleOrderField["ID"] = "ID";
    ClassroomRoleOrderField["NAME"] = "NAME";
    ClassroomRoleOrderField["ORGANIZATION"] = "ORGANIZATION";
})(ClassroomRoleOrderField || (ClassroomRoleOrderField = {}));
export var ClassroomSettingOrderField;
(function (ClassroomSettingOrderField) {
    ClassroomSettingOrderField["APP_ID"] = "APP_ID";
    ClassroomSettingOrderField["CLASSROOM_ID"] = "CLASSROOM_ID";
    ClassroomSettingOrderField["SETTING"] = "SETTING";
})(ClassroomSettingOrderField || (ClassroomSettingOrderField = {}));
export var ClassroomStatus;
(function (ClassroomStatus) {
    ClassroomStatus["ACTIVE"] = "ACTIVE";
    ClassroomStatus["ARCHIVED"] = "ARCHIVED";
    ClassroomStatus["REMOVED"] = "REMOVED";
})(ClassroomStatus || (ClassroomStatus = {}));
export var ClientDevice;
(function (ClientDevice) {
    ClientDevice["CHROMEBOOK"] = "CHROMEBOOK";
    ClientDevice["DESKTOP"] = "DESKTOP";
    ClientDevice["IPAD"] = "IPAD";
})(ClientDevice || (ClientDevice = {}));
export var CmsResponseType;
(function (CmsResponseType) {
    CmsResponseType["SUCCESS"] = "SUCCESS";
})(CmsResponseType || (CmsResponseType = {}));
export var ContactOrderField;
(function (ContactOrderField) {
    ContactOrderField["ID"] = "ID";
    ContactOrderField["SOURCE_ID"] = "SOURCE_ID";
    ContactOrderField["SOURCE_KIND_ID"] = "SOURCE_KIND_ID";
})(ContactOrderField || (ContactOrderField = {}));
export var CourseOrderField;
(function (CourseOrderField) {
    CourseOrderField["DATE_CREATED"] = "DATE_CREATED";
    CourseOrderField["DATE_REMOVED"] = "DATE_REMOVED";
    CourseOrderField["DESCRIPTION"] = "DESCRIPTION";
    CourseOrderField["FILENAME"] = "FILENAME";
    CourseOrderField["ID"] = "ID";
    CourseOrderField["TITLE"] = "TITLE";
})(CourseOrderField || (CourseOrderField = {}));
export var EnrollmentOrderField;
(function (EnrollmentOrderField) {
    EnrollmentOrderField["CLASSROOM_ROLE"] = "CLASSROOM_ROLE";
    EnrollmentOrderField["CLASSROOM_ROLE_ID"] = "CLASSROOM_ROLE_ID";
    EnrollmentOrderField["STUDENT_ID"] = "STUDENT_ID";
    EnrollmentOrderField["USER_ID"] = "USER_ID";
})(EnrollmentOrderField || (EnrollmentOrderField = {}));
export var EquationBuilderOperator;
(function (EquationBuilderOperator) {
    EquationBuilderOperator["ADDITION"] = "ADDITION";
    EquationBuilderOperator["CLOSE_PARENTHESES"] = "CLOSE_PARENTHESES";
    EquationBuilderOperator["DIVISION"] = "DIVISION";
    EquationBuilderOperator["EQUALITY"] = "EQUALITY";
    EquationBuilderOperator["EXPONENTIATION"] = "EXPONENTIATION";
    EquationBuilderOperator["MODULUS"] = "MODULUS";
    EquationBuilderOperator["MULTIPLICATION"] = "MULTIPLICATION";
    EquationBuilderOperator["OPEN_PARENTHESES"] = "OPEN_PARENTHESES";
    EquationBuilderOperator["SUBTRACTION"] = "SUBTRACTION";
})(EquationBuilderOperator || (EquationBuilderOperator = {}));
export var FeatureToggleOrderField;
(function (FeatureToggleOrderField) {
    FeatureToggleOrderField["APP_ID"] = "APP_ID";
    FeatureToggleOrderField["DATE_CREATED"] = "DATE_CREATED";
    FeatureToggleOrderField["ENABLED"] = "ENABLED";
    FeatureToggleOrderField["ID"] = "ID";
    FeatureToggleOrderField["NAME"] = "NAME";
})(FeatureToggleOrderField || (FeatureToggleOrderField = {}));
export var GroupCategoryOrderField;
(function (GroupCategoryOrderField) {
    GroupCategoryOrderField["CLASSROOM_ID"] = "CLASSROOM_ID";
    GroupCategoryOrderField["ID"] = "ID";
    GroupCategoryOrderField["NAME"] = "NAME";
})(GroupCategoryOrderField || (GroupCategoryOrderField = {}));
export var GroupEnrollmentAction;
(function (GroupEnrollmentAction) {
    GroupEnrollmentAction["ENROLL"] = "ENROLL";
    GroupEnrollmentAction["UNENROLL"] = "UNENROLL";
})(GroupEnrollmentAction || (GroupEnrollmentAction = {}));
export var GroupEnrollmentOrderField;
(function (GroupEnrollmentOrderField) {
    GroupEnrollmentOrderField["GROUP_ID"] = "GROUP_ID";
    GroupEnrollmentOrderField["ID"] = "ID";
    GroupEnrollmentOrderField["STUDENT_ID"] = "STUDENT_ID";
})(GroupEnrollmentOrderField || (GroupEnrollmentOrderField = {}));
export var GroupOrderField;
(function (GroupOrderField) {
    GroupOrderField["CLASSROOM_ID"] = "CLASSROOM_ID";
    GroupOrderField["GROUP_CATEGORY_ID"] = "GROUP_CATEGORY_ID";
    GroupOrderField["ID"] = "ID";
    GroupOrderField["NAME"] = "NAME";
})(GroupOrderField || (GroupOrderField = {}));
export var HearItTypeItAnswerType;
(function (HearItTypeItAnswerType) {
    HearItTypeItAnswerType["LETTER"] = "LETTER";
    HearItTypeItAnswerType["SENTENCE"] = "SENTENCE";
    HearItTypeItAnswerType["WORD"] = "WORD";
})(HearItTypeItAnswerType || (HearItTypeItAnswerType = {}));
export var KeyboardingActivityCategory;
(function (KeyboardingActivityCategory) {
    KeyboardingActivityCategory["ASSESSMENT_ACCELERATOR_ELA"] = "ASSESSMENT_ACCELERATOR_ELA";
    KeyboardingActivityCategory["ASSESSMENT_ACCELERATOR_MATH"] = "ASSESSMENT_ACCELERATOR_MATH";
    KeyboardingActivityCategory["ASSESSMENT_ACCELERATOR_STEM"] = "ASSESSMENT_ACCELERATOR_STEM";
    KeyboardingActivityCategory["CURRICULUM"] = "CURRICULUM";
    KeyboardingActivityCategory["ENRICHMENT"] = "ENRICHMENT";
})(KeyboardingActivityCategory || (KeyboardingActivityCategory = {}));
export var KeyboardingActivityOrderField;
(function (KeyboardingActivityOrderField) {
    KeyboardingActivityOrderField["ID"] = "ID";
    KeyboardingActivityOrderField["TITLE"] = "TITLE";
})(KeyboardingActivityOrderField || (KeyboardingActivityOrderField = {}));
export var KeyboardingActivityTypeOrderField;
(function (KeyboardingActivityTypeOrderField) {
    KeyboardingActivityTypeOrderField["ID"] = "ID";
    KeyboardingActivityTypeOrderField["NAME"] = "NAME";
})(KeyboardingActivityTypeOrderField || (KeyboardingActivityTypeOrderField = {}));
export var KeyboardingActivityTypeVariantOrderField;
(function (KeyboardingActivityTypeVariantOrderField) {
    KeyboardingActivityTypeVariantOrderField["ID"] = "ID";
    KeyboardingActivityTypeVariantOrderField["NAME"] = "NAME";
})(KeyboardingActivityTypeVariantOrderField || (KeyboardingActivityTypeVariantOrderField = {}));
export var KeyboardingActivityVideoOrderField;
(function (KeyboardingActivityVideoOrderField) {
    KeyboardingActivityVideoOrderField["ID"] = "ID";
    KeyboardingActivityVideoOrderField["NAME"] = "NAME";
})(KeyboardingActivityVideoOrderField || (KeyboardingActivityVideoOrderField = {}));
export var KeyboardingCurriculumActivityOrderField;
(function (KeyboardingCurriculumActivityOrderField) {
    KeyboardingCurriculumActivityOrderField["ID"] = "ID";
    KeyboardingCurriculumActivityOrderField["WEEK"] = "WEEK";
})(KeyboardingCurriculumActivityOrderField || (KeyboardingCurriculumActivityOrderField = {}));
export var KeyboardingCurriculumOrderField;
(function (KeyboardingCurriculumOrderField) {
    KeyboardingCurriculumOrderField["ID"] = "ID";
    KeyboardingCurriculumOrderField["NAME"] = "NAME";
    KeyboardingCurriculumOrderField["PRODUCT_CURRICULUM_ID"] = "PRODUCT_CURRICULUM_ID";
})(KeyboardingCurriculumOrderField || (KeyboardingCurriculumOrderField = {}));
export var KeyboardingCurriculumThemeOrderField;
(function (KeyboardingCurriculumThemeOrderField) {
    KeyboardingCurriculumThemeOrderField["ID"] = "ID";
    KeyboardingCurriculumThemeOrderField["NAME"] = "NAME";
})(KeyboardingCurriculumThemeOrderField || (KeyboardingCurriculumThemeOrderField = {}));
export var KeyboardingCurriculumVideoOrderField;
(function (KeyboardingCurriculumVideoOrderField) {
    KeyboardingCurriculumVideoOrderField["ID"] = "ID";
    KeyboardingCurriculumVideoOrderField["NAME"] = "NAME";
})(KeyboardingCurriculumVideoOrderField || (KeyboardingCurriculumVideoOrderField = {}));
export var KeyboardingCurriculumWeekOrderField;
(function (KeyboardingCurriculumWeekOrderField) {
    KeyboardingCurriculumWeekOrderField["CURRICULUM_ID"] = "CURRICULUM_ID";
    KeyboardingCurriculumWeekOrderField["ID"] = "ID";
    KeyboardingCurriculumWeekOrderField["NAME"] = "NAME";
})(KeyboardingCurriculumWeekOrderField || (KeyboardingCurriculumWeekOrderField = {}));
export var KeyboardingDynamicContentLayout;
(function (KeyboardingDynamicContentLayout) {
    KeyboardingDynamicContentLayout["COLUMN"] = "COLUMN";
    KeyboardingDynamicContentLayout["ROW"] = "ROW";
})(KeyboardingDynamicContentLayout || (KeyboardingDynamicContentLayout = {}));
export var KeyboardingKeyboardOrderField;
(function (KeyboardingKeyboardOrderField) {
    KeyboardingKeyboardOrderField["ID"] = "ID";
    KeyboardingKeyboardOrderField["NAME"] = "NAME";
    KeyboardingKeyboardOrderField["ROOFS"] = "ROOFS";
    KeyboardingKeyboardOrderField["SHOW_NUMBERS"] = "SHOW_NUMBERS";
    KeyboardingKeyboardOrderField["TYPE"] = "TYPE";
})(KeyboardingKeyboardOrderField || (KeyboardingKeyboardOrderField = {}));
export var KeyboardingKeyboardType;
(function (KeyboardingKeyboardType) {
    KeyboardingKeyboardType["KEYBOARD_35"] = "KEYBOARD_35";
    KeyboardingKeyboardType["KEYBOARD_K2"] = "KEYBOARD_K2";
})(KeyboardingKeyboardType || (KeyboardingKeyboardType = {}));
export var KeyboardingModuleOrderField;
(function (KeyboardingModuleOrderField) {
    KeyboardingModuleOrderField["ID"] = "ID";
    KeyboardingModuleOrderField["NAME"] = "NAME";
})(KeyboardingModuleOrderField || (KeyboardingModuleOrderField = {}));
export var KeyboardingModuleVideoOrderField;
(function (KeyboardingModuleVideoOrderField) {
    KeyboardingModuleVideoOrderField["ID"] = "ID";
    KeyboardingModuleVideoOrderField["NAME"] = "NAME";
})(KeyboardingModuleVideoOrderField || (KeyboardingModuleVideoOrderField = {}));
export var KeyboardingTableColumnType;
(function (KeyboardingTableColumnType) {
    KeyboardingTableColumnType["BOOLEAN"] = "BOOLEAN";
    KeyboardingTableColumnType["NUMBER"] = "NUMBER";
    KeyboardingTableColumnType["STRING"] = "STRING";
    KeyboardingTableColumnType["TALLY_MARK"] = "TALLY_MARK";
})(KeyboardingTableColumnType || (KeyboardingTableColumnType = {}));
export var LicenseAction;
(function (LicenseAction) {
    LicenseAction["ASSIGN"] = "ASSIGN";
    LicenseAction["UNASSIGN"] = "UNASSIGN";
})(LicenseAction || (LicenseAction = {}));
export var LicenseOrderField;
(function (LicenseOrderField) {
    LicenseOrderField["DATE_CREATED"] = "DATE_CREATED";
    LicenseOrderField["DATE_EXPIRATION"] = "DATE_EXPIRATION";
    LicenseOrderField["DATE_UPDATED"] = "DATE_UPDATED";
    LicenseOrderField["DATE_UPDATED_ASSIGNMENT"] = "DATE_UPDATED_ASSIGNMENT";
    LicenseOrderField["ID"] = "ID";
    LicenseOrderField["ORDER_ITEM_ID"] = "ORDER_ITEM_ID";
    LicenseOrderField["ORGANIZATION_ID"] = "ORGANIZATION_ID";
    LicenseOrderField["PRODUCT_CURRICULUM_ID"] = "PRODUCT_CURRICULUM_ID";
    LicenseOrderField["PRODUCT_ID"] = "PRODUCT_ID";
    LicenseOrderField["STUDENT_ID"] = "STUDENT_ID";
    LicenseOrderField["USER_ID"] = "USER_ID";
})(LicenseOrderField || (LicenseOrderField = {}));
export var LicenseStatus;
(function (LicenseStatus) {
    LicenseStatus["ACTIVE"] = "ACTIVE";
    LicenseStatus["EXPIRED"] = "EXPIRED";
    LicenseStatus["REMOVED"] = "REMOVED";
})(LicenseStatus || (LicenseStatus = {}));
export var LicenseType;
(function (LicenseType) {
    LicenseType["ADD_ON"] = "ADD_ON";
    LicenseType["EMPLOYEE"] = "EMPLOYEE";
    LicenseType["FULL"] = "FULL";
    LicenseType["MULTI_YEAR"] = "MULTI_YEAR";
    LicenseType["OVERAGE"] = "OVERAGE";
    LicenseType["PRORATED"] = "PRORATED";
    LicenseType["RENEWAL"] = "RENEWAL";
    LicenseType["TRIAL"] = "TRIAL";
    LicenseType["WORKSHOP"] = "WORKSHOP";
})(LicenseType || (LicenseType = {}));
export var Locale;
(function (Locale) {
    Locale["EN_US"] = "EN_US";
    Locale["ES_US"] = "ES_US";
})(Locale || (Locale = {}));
export var MastercodeOrderField;
(function (MastercodeOrderField) {
    MastercodeOrderField["CODE"] = "CODE";
    MastercodeOrderField["DATE_CREATED"] = "DATE_CREATED";
    MastercodeOrderField["DATE_REMOVED"] = "DATE_REMOVED";
    MastercodeOrderField["DATE_SCHEDULED_UNLOCK"] = "DATE_SCHEDULED_UNLOCK";
    MastercodeOrderField["DATE_UNLOCKED"] = "DATE_UNLOCKED";
    MastercodeOrderField["ID"] = "ID";
    MastercodeOrderField["OWNER_EMAIL"] = "OWNER_EMAIL";
})(MastercodeOrderField || (MastercodeOrderField = {}));
export var MastercodeStatus;
(function (MastercodeStatus) {
    MastercodeStatus["EXPIRED"] = "EXPIRED";
    MastercodeStatus["LOCKED"] = "LOCKED";
    MastercodeStatus["REMOVED"] = "REMOVED";
    MastercodeStatus["SCHEDULED"] = "SCHEDULED";
    MastercodeStatus["UNLOCKED"] = "UNLOCKED";
})(MastercodeStatus || (MastercodeStatus = {}));
export var MastercodeTransferHistoryOrderField;
(function (MastercodeTransferHistoryOrderField) {
    MastercodeTransferHistoryOrderField["DATE_TRANSERRED"] = "DATE_TRANSERRED";
    MastercodeTransferHistoryOrderField["ID"] = "ID";
    MastercodeTransferHistoryOrderField["MASTERCODE_ID"] = "MASTERCODE_ID";
    MastercodeTransferHistoryOrderField["NEW_OWNER_EMAIL"] = "NEW_OWNER_EMAIL";
    MastercodeTransferHistoryOrderField["PREVIOUS_OWNER_EMAIL"] = "PREVIOUS_OWNER_EMAIL";
})(MastercodeTransferHistoryOrderField || (MastercodeTransferHistoryOrderField = {}));
export var MatManMatchShape;
(function (MatManMatchShape) {
    MatManMatchShape["CIRCLE"] = "CIRCLE";
    MatManMatchShape["DIAMOND"] = "DIAMOND";
    MatManMatchShape["HEART"] = "HEART";
    MatManMatchShape["HEXAGON"] = "HEXAGON";
    MatManMatchShape["MOON"] = "MOON";
    MatManMatchShape["OCTAGON"] = "OCTAGON";
    MatManMatchShape["OVAL"] = "OVAL";
    MatManMatchShape["PENTAGON"] = "PENTAGON";
    MatManMatchShape["RECTANGLE"] = "RECTANGLE";
    MatManMatchShape["SQUARE"] = "SQUARE";
    MatManMatchShape["STAR"] = "STAR";
    MatManMatchShape["TRIANGLE"] = "TRIANGLE";
})(MatManMatchShape || (MatManMatchShape = {}));
export var MediaType;
(function (MediaType) {
    MediaType["AUDIO"] = "AUDIO";
    MediaType["IMAGE"] = "IMAGE";
    MediaType["VIDEO"] = "VIDEO";
})(MediaType || (MediaType = {}));
export var MrsNewsSyllablesFormattingTool;
(function (MrsNewsSyllablesFormattingTool) {
    MrsNewsSyllablesFormattingTool["BOLD"] = "BOLD";
    MrsNewsSyllablesFormattingTool["ITALIC"] = "ITALIC";
    MrsNewsSyllablesFormattingTool["UNDERLINE"] = "UNDERLINE";
})(MrsNewsSyllablesFormattingTool || (MrsNewsSyllablesFormattingTool = {}));
export var MrsNewsSyllablesStepType;
(function (MrsNewsSyllablesStepType) {
    MrsNewsSyllablesStepType["DEFINITION"] = "DEFINITION";
    MrsNewsSyllablesStepType["SENTENCE"] = "SENTENCE";
    MrsNewsSyllablesStepType["SYLLABLE"] = "SYLLABLE";
})(MrsNewsSyllablesStepType || (MrsNewsSyllablesStepType = {}));
export var MyChoiceKeyboardingQuestionType;
(function (MyChoiceKeyboardingQuestionType) {
    MyChoiceKeyboardingQuestionType["FILL_IN_THE_BLANK"] = "FILL_IN_THE_BLANK";
    MyChoiceKeyboardingQuestionType["PARAGRAPH"] = "PARAGRAPH";
    MyChoiceKeyboardingQuestionType["SENTENCE"] = "SENTENCE";
})(MyChoiceKeyboardingQuestionType || (MyChoiceKeyboardingQuestionType = {}));
export var OrderDirection;
(function (OrderDirection) {
    OrderDirection["ASC"] = "ASC";
    OrderDirection["DESC"] = "DESC";
})(OrderDirection || (OrderDirection = {}));
export var OrderOrderField;
(function (OrderOrderField) {
    OrderOrderField["DATE_CREATED"] = "DATE_CREATED";
    OrderOrderField["DATE_FULFILLED"] = "DATE_FULFILLED";
    OrderOrderField["DATE_ORDERED"] = "DATE_ORDERED";
    OrderOrderField["DATE_REMOVED"] = "DATE_REMOVED";
    OrderOrderField["ID"] = "ID";
    OrderOrderField["ORDER_NUMBER"] = "ORDER_NUMBER";
    OrderOrderField["TYPE"] = "TYPE";
    OrderOrderField["WEBSTORE_ORDER_NUMBER"] = "WEBSTORE_ORDER_NUMBER";
})(OrderOrderField || (OrderOrderField = {}));
export var OrganizationOrderField;
(function (OrganizationOrderField) {
    OrganizationOrderField["ID"] = "ID";
    OrganizationOrderField["NAME"] = "NAME";
    OrganizationOrderField["ORGANIZATION_TYPE_ID"] = "ORGANIZATION_TYPE_ID";
    OrganizationOrderField["PARENT_ORGANIZATION_ID"] = "PARENT_ORGANIZATION_ID";
    OrganizationOrderField["SOURCE_ID"] = "SOURCE_ID";
    OrganizationOrderField["SOURCE_KIND_ID"] = "SOURCE_KIND_ID";
})(OrganizationOrderField || (OrganizationOrderField = {}));
export var OrganizationPrivilegeOrderField;
(function (OrganizationPrivilegeOrderField) {
    OrganizationPrivilegeOrderField["ID"] = "ID";
    OrganizationPrivilegeOrderField["NAME"] = "NAME";
})(OrganizationPrivilegeOrderField || (OrganizationPrivilegeOrderField = {}));
export var OrganizationRoleClassification;
(function (OrganizationRoleClassification) {
    OrganizationRoleClassification["ADMIN"] = "ADMIN";
    OrganizationRoleClassification["AUDITOR"] = "AUDITOR";
    OrganizationRoleClassification["FACULTY"] = "FACULTY";
})(OrganizationRoleClassification || (OrganizationRoleClassification = {}));
export var OrganizationRoleOrderField;
(function (OrganizationRoleOrderField) {
    OrganizationRoleOrderField["APP"] = "APP";
    OrganizationRoleOrderField["ID"] = "ID";
    OrganizationRoleOrderField["NAME"] = "NAME";
    OrganizationRoleOrderField["ORGANIZATION"] = "ORGANIZATION";
})(OrganizationRoleOrderField || (OrganizationRoleOrderField = {}));
export var OrganizationSettingOrderField;
(function (OrganizationSettingOrderField) {
    OrganizationSettingOrderField["APP_ID"] = "APP_ID";
    OrganizationSettingOrderField["ORGANIZATION_ID"] = "ORGANIZATION_ID";
    OrganizationSettingOrderField["SETTING"] = "SETTING";
})(OrganizationSettingOrderField || (OrganizationSettingOrderField = {}));
export var OrganizationType;
(function (OrganizationType) {
    OrganizationType["DEPARTMENT"] = "DEPARTMENT";
    OrganizationType["DISTRICT"] = "DISTRICT";
    OrganizationType["LOCAL"] = "LOCAL";
    OrganizationType["NATIONAL"] = "NATIONAL";
    OrganizationType["SCHOOL"] = "SCHOOL";
    OrganizationType["STATE"] = "STATE";
    OrganizationType["USER_GROUP"] = "USER_GROUP";
})(OrganizationType || (OrganizationType = {}));
export var Placement;
(function (Placement) {
    Placement["ABOVE"] = "ABOVE";
    Placement["BELOW"] = "BELOW";
    Placement["LEFT"] = "LEFT";
    Placement["RIGHT"] = "RIGHT";
})(Placement || (Placement = {}));
export var ProductBundleOrderField;
(function (ProductBundleOrderField) {
    ProductBundleOrderField["CODE"] = "CODE";
    ProductBundleOrderField["DATE_CREATED"] = "DATE_CREATED";
    ProductBundleOrderField["DATE_UPDATED"] = "DATE_UPDATED";
    ProductBundleOrderField["ID"] = "ID";
    ProductBundleOrderField["NAME"] = "NAME";
})(ProductBundleOrderField || (ProductBundleOrderField = {}));
export var ProductCurriculumOrderField;
(function (ProductCurriculumOrderField) {
    ProductCurriculumOrderField["CODE"] = "CODE";
    ProductCurriculumOrderField["ID"] = "ID";
    ProductCurriculumOrderField["NAME"] = "NAME";
    ProductCurriculumOrderField["PRODUCT_ID"] = "PRODUCT_ID";
    ProductCurriculumOrderField["TRIAL_AVAILABLE"] = "TRIAL_AVAILABLE";
})(ProductCurriculumOrderField || (ProductCurriculumOrderField = {}));
export var ProductFamilyOrderField;
(function (ProductFamilyOrderField) {
    ProductFamilyOrderField["CODE"] = "CODE";
    ProductFamilyOrderField["ID"] = "ID";
    ProductFamilyOrderField["NAME"] = "NAME";
})(ProductFamilyOrderField || (ProductFamilyOrderField = {}));
export var ProductOrderField;
(function (ProductOrderField) {
    ProductOrderField["CODE"] = "CODE";
    ProductOrderField["ID"] = "ID";
    ProductOrderField["NAME"] = "NAME";
    ProductOrderField["PRODUCT_FAMILY_ID"] = "PRODUCT_FAMILY_ID";
    ProductOrderField["TRIAL_AVAILABLE"] = "TRIAL_AVAILABLE";
})(ProductOrderField || (ProductOrderField = {}));
export var ProductType;
(function (ProductType) {
    ProductType["STUDENT"] = "STUDENT";
    ProductType["USER"] = "USER";
})(ProductType || (ProductType = {}));
export var SiteLicenseOrderField;
(function (SiteLicenseOrderField) {
    SiteLicenseOrderField["DATE_CREATED"] = "DATE_CREATED";
    SiteLicenseOrderField["DATE_EXPIRATION"] = "DATE_EXPIRATION";
    SiteLicenseOrderField["DATE_UPDATED"] = "DATE_UPDATED";
    SiteLicenseOrderField["DATE_UPDATED_ASSIGNMENT"] = "DATE_UPDATED_ASSIGNMENT";
    SiteLicenseOrderField["ID"] = "ID";
    SiteLicenseOrderField["PRODUCT_ID"] = "PRODUCT_ID";
})(SiteLicenseOrderField || (SiteLicenseOrderField = {}));
export var SourceKind;
(function (SourceKind) {
    SourceKind["CLASS_LINK"] = "CLASS_LINK";
    SourceKind["CLEVER"] = "CLEVER";
    SourceKind["FIREBASE"] = "FIREBASE";
    SourceKind["GOOGLE"] = "GOOGLE";
    SourceKind["ONE_ROSTER"] = "ONE_ROSTER";
})(SourceKind || (SourceKind = {}));
export var StudentLoginType;
(function (StudentLoginType) {
    StudentLoginType["LETTER_CARDS"] = "LETTER_CARDS";
    StudentLoginType["TEXTBOX"] = "TEXTBOX";
})(StudentLoginType || (StudentLoginType = {}));
export var StudentSearchField;
(function (StudentSearchField) {
    StudentSearchField["FIRST_NAME"] = "FIRST_NAME";
    StudentSearchField["LAST_NAME"] = "LAST_NAME";
})(StudentSearchField || (StudentSearchField = {}));
export var StudentSettingOrderField;
(function (StudentSettingOrderField) {
    StudentSettingOrderField["APP_ID"] = "APP_ID";
    StudentSettingOrderField["SETTING"] = "SETTING";
    StudentSettingOrderField["STUDENT_ID"] = "STUDENT_ID";
})(StudentSettingOrderField || (StudentSettingOrderField = {}));
export var StudentStatus;
(function (StudentStatus) {
    StudentStatus["ACTIVE"] = "ACTIVE";
    StudentStatus["REMOVED"] = "REMOVED";
})(StudentStatus || (StudentStatus = {}));
export var StudentsOrderField;
(function (StudentsOrderField) {
    StudentsOrderField["FIRST_NAME"] = "FIRST_NAME";
    StudentsOrderField["GRADE_LEVEL"] = "GRADE_LEVEL";
    StudentsOrderField["ID"] = "ID";
    StudentsOrderField["LAST_NAME"] = "LAST_NAME";
    StudentsOrderField["PASSWORD"] = "PASSWORD";
    StudentsOrderField["SOURCE_ID"] = "SOURCE_ID";
    StudentsOrderField["SOURCE_KIND_ID"] = "SOURCE_KIND_ID";
    StudentsOrderField["USERNAME"] = "USERNAME";
})(StudentsOrderField || (StudentsOrderField = {}));
export var TourOrderField;
(function (TourOrderField) {
    TourOrderField["APP_ID"] = "APP_ID";
    TourOrderField["ID"] = "ID";
    TourOrderField["NAME"] = "NAME";
})(TourOrderField || (TourOrderField = {}));
export var UserOrderField;
(function (UserOrderField) {
    UserOrderField["FIRST_NAME"] = "FIRST_NAME";
    UserOrderField["ID"] = "ID";
    UserOrderField["LAST_NAME"] = "LAST_NAME";
    UserOrderField["SOURCE_ID"] = "SOURCE_ID";
    UserOrderField["SOURCE_KIND_ID"] = "SOURCE_KIND_ID";
    UserOrderField["USERNAME"] = "USERNAME";
})(UserOrderField || (UserOrderField = {}));
export var UserRole;
(function (UserRole) {
    UserRole["COEDUCATOR"] = "COEDUCATOR";
    UserRole["COEDUCATOR_GSS"] = "COEDUCATOR_GSS";
    UserRole["COEDUCATOR_KEY"] = "COEDUCATOR_KEY";
    UserRole["EDUCATOR"] = "EDUCATOR";
    UserRole["EDUCATOR_GSS"] = "EDUCATOR_GSS";
    UserRole["EDUCATOR_KEY"] = "EDUCATOR_KEY";
})(UserRole || (UserRole = {}));
export var UserSearchField;
(function (UserSearchField) {
    UserSearchField["FIRST_NAME"] = "FIRST_NAME";
    UserSearchField["LAST_NAME"] = "LAST_NAME";
    UserSearchField["USERNAME"] = "USERNAME";
})(UserSearchField || (UserSearchField = {}));
export var UserSettingOrderField;
(function (UserSettingOrderField) {
    UserSettingOrderField["APP_ID"] = "APP_ID";
    UserSettingOrderField["SETTING"] = "SETTING";
    UserSettingOrderField["USER_ID"] = "USER_ID";
})(UserSettingOrderField || (UserSettingOrderField = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["INACTIVE"] = "INACTIVE";
    UserStatus["PENDING"] = "PENDING";
})(UserStatus || (UserStatus = {}));
export var UserType;
(function (UserType) {
    UserType["ADMINISTRATOR"] = "ADMINISTRATOR";
    UserType["CURRICULUM"] = "CURRICULUM";
    UserType["ESL_ESOL"] = "ESL_ESOL";
    UserType["HOMESCHOOL_EDUCATOR"] = "HOMESCHOOL_EDUCATOR";
    UserType["K5_TEACHER"] = "K5_TEACHER";
    UserType["OCCUPATIONAL_THERAPIST"] = "OCCUPATIONAL_THERAPIST";
    UserType["OTHER"] = "OTHER";
    UserType["PARENT_FAMILY"] = "PARENT_FAMILY";
    UserType["PREK_TEACHER"] = "PREK_TEACHER";
    UserType["PRINCIPAL_VICE_PRINCIPAL"] = "PRINCIPAL_VICE_PRINCIPAL";
    UserType["READING_SPECIALIST"] = "READING_SPECIALIST";
    UserType["SPECIAL_EDUCATION"] = "SPECIAL_EDUCATION";
    UserType["TECHNOLOGY_MEDIA"] = "TECHNOLOGY_MEDIA";
})(UserType || (UserType = {}));
export var VennDiagramPosition;
(function (VennDiagramPosition) {
    VennDiagramPosition["CENTER"] = "CENTER";
    VennDiagramPosition["LEFT"] = "LEFT";
    VennDiagramPosition["RIGHT"] = "RIGHT";
})(VennDiagramPosition || (VennDiagramPosition = {}));
export var Weekday;
(function (Weekday) {
    Weekday["FRIDAY"] = "FRIDAY";
    Weekday["MONDAY"] = "MONDAY";
    Weekday["SATURDAY"] = "SATURDAY";
    Weekday["SUNDAY"] = "SUNDAY";
    Weekday["THURSDAY"] = "THURSDAY";
    Weekday["TUESDAY"] = "TUESDAY";
    Weekday["WEDNESDAY"] = "WEDNESDAY";
})(Weekday || (Weekday = {}));
